import React from "react";
import { Dropdown } from "../../common/components/dropdownSelect";
import { formGroup } from "../../common/components/formGroup";
import { InterventoDto } from "../../generated";
import { Loading } from "../../common/components/loading"
import DatesHelper from "../../common/datesHelper";
import InterventiStore from "../interventiStore";
import { orderBy } from "lodash";
import { InterventoChecksLabels } from "./interventiClienteWidget";
import TechnicianViewer from "../../technicians/components/TechnicianViewer";

const DropdownList = Dropdown<InterventoDto>();
interface Props {
    label?: string;
    idCliente: number | undefined;
    filter?: (x: InterventoDto) => boolean;
    value: InterventoDto | number | null,
    onChange: (type: InterventoDto | null) => void
    error?: string;
    allowNull?: boolean;
    readOnly?: boolean;
}

const ItemComponent = ({ item }: { item: InterventoDto }) => <div className="d-flex flex-column">
    <div>{DatesHelper.getReadableDateString(item.dataIntervento)} <strong>{item.tipoIntervento.descTipoIntervento}</strong></div>
    <div className="d-flex flex-wrap justify-content-between">
        <InterventoChecksLabels intervento={item} />
        {item.idTechnician && <TechnicianViewer id={item.idTechnician}
            template={x => <span style={{ whiteSpace: "nowrap" }}><i className="fas fa-circle fa-lg" style={{ color: x.color }} /> {x.firstName} {x.lastName}</span>}
        />}
    </div>
</div>

const __InterventoSelector = ({ idCliente, allowNull, onChange, value, error, label, readOnly, filter }: Props) => {
    const interventi = idCliente ? InterventiStore.useForCliente(idCliente) : [];
    if (!interventi)
        return <Loading />
    const filtered = filter ? interventi.filter(filter) : interventi;
    const sorted = orderBy(filtered, x => x.dataIntervento, ["desc"]);
    const selectedItem = typeof value == "number" ? sorted.find(x => x.idIntervento == value) ?? null : value;
    return <DropdownList
        label={label ?? "Impianto"}
        allowNull={allowNull}
        data={sorted}
        itemComponent={ItemComponent}
        textField={x => ""}
        onSelect={onChange}
        value={selectedItem}
        error={error}
        readonly={readOnly || sorted.length == 0}
    />;
}
export const InterventiSelector = formGroup(__InterventoSelector)

